module.exports = __webpack_public_path__ + "img/NEWCR.989b97bd.svg";